<template>
    <v-dialog
        v-model="showDialog"
        width="600"
        persistent
    >
        <v-card>
            <v-form
                ref="form"
                v-model="form"
                @submit.prevent="submitForm"
            >
                <v-card-title style="background-color: #009688; color: white;">
                    Edit Diagnostic: &nbsp;<v-chip>{{ editDiagnostic.DIA_T }}</v-chip>
                </v-card-title>
                <v-card-text>
                    <v-text-field
                        v-model.trim="diagnosticName"
                        label="Diagnostic"
                        clearable
                        :rules="[v => v && v.trim().length > 0 || 'This field is required']"
                    />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="teal darken-1"
                        outlined
                        width="120"
                        @click="showDialog = false"
                    >
                        <v-icon>{{ mdiClose }}</v-icon>
                        close
                    </v-btn>
                    <v-btn
                        color="teal darken-1"
                        width="120"
                        style="color: white;"
                        type="submit"
                    >
                        <v-icon>{{ mdiCheck }}</v-icon>
                        save
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
    mdiClose,
    mdiCheck
} from '@mdi/js'

export default {
    props: ['show', 'data', 'notif'],
    data: ()=>({
        mdiClose,
        mdiCheck,
        form: false,
        editDiagnostic: {
            DIA_T: null
        },
        diagnosticName: null
    }),
    computed: {
        ...mapGetters(['editDiagnosticPackageData']),
        showDialog: {
            get() {
                return this.show
            },
            set() {
                this.$refs.form.reset()
                this.$emit('closeDialog')
            }
        }
    },
    watch: {
        editDiagnosticPackageData(newVal) {
            if (newVal) {
                if (newVal.status === 200) {
                    this.notif.type = 'success'
                    this.notif.color = 'success'
                    this.notif.timeout = 5000
                    this.notif.msg = 'Diagnostic has been updated.'
                    this.notif.show = true
                    this.getPackageDiagnostics({ RATE_ID: this.data.RATE_ID })
                    this.showDialog = false
                } else {
                    this.notif.type = 'error'
                    this.notif.color = 'error'
                    this.notif.timeout = 5000
                    this.notif.msg = newVal.state
                    this.notif.show = true
                }
            }
        },
        data(newVal) {
            this.editDiagnostic = structuredClone(newVal)
            this.diagnosticName = this.editDiagnostic.DIA_T
        }
    },
    methods: {
        ...mapActions(['editDiagnosticPackage', 'getPackageDiagnostics']),
        submitForm() {
            if (this.$refs.form.validate()) {
                const arg = {
                    ID : this.editDiagnostic.ID,
                    RATE_ID: this.editDiagnostic.RATE_ID,
                    DIA_T: this.diagnosticName
                }
                this.editDiagnosticPackage(arg)
            }
        }
    }
}
</script>
